/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Meal_PlanInputs */

const en_service_type_meal_plan = /** @type {(inputs: Service_Type_Meal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal plan`)
};

const pl_service_type_meal_plan = /** @type {(inputs: Service_Type_Meal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadłospis`)
};

/**
* | output |
* | --- |
* | "Meal plan" |
*
* @param {Service_Type_Meal_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_meal_plan = /** @type {((inputs?: Service_Type_Meal_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Meal_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_meal_plan(inputs)
	return en_service_type_meal_plan(inputs)
});